/* ==========================================================================
 *  Function: Select Language
 * ======================================================================= */
function fn_parts_select_language(){
	if ($( '.js-select-language' ).length){
		$( '.js-select-language' ).on( 'click' , function () {
			var inst = $(this);
			var language = $(this).data('language');
			var text = $(this).text();
			inst.closest( '.js-dropdown-block' ).find('.js-dropdown-trigger').text(text);
			changeLanguage(language, text);
		});

		function changeLanguage(language, text){
			console.log('Text položky: ' + text);
			console.log('Atribut položky: ' + language);
		}
	}
}